import { RouteState } from "@/router/RouteState";

/** 주소로 직접 진입한 일반 직원·법인 관리자의 통합관리 차단 화면. */
export function GroupDenied() {
  return <RouteState kind="denied" description={<>
    통합관리는 <strong>전체 관리자</strong>만 볼 수 있어요.<br />
    계정·소속 변경이 필요하다면 관리자에게 문의해 주세요.
  </>} />;
}
